var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2826",
    "data-name": "Group 2826",
    transform: "translate(-1075 -202)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1404",
    "data-name": "Rectangle 1404",
    width: 35,
    height: 35,
    rx: 17.5,
    transform: "translate(1075 202)",
    fill: "#e6eef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-forward",
    "data-name": "Icon ionic-ios-arrow-forward",
    d: "M4.89,5.968.257,1.453a.835.835,0,0,1,0-1.205A.9.9,0,0,1,1.5.248L6.745,5.364A.837.837,0,0,1,6.771,6.54L1.5,11.692a.9.9,0,0,1-1.239,0,.835.835,0,0,1,0-1.205Z",
    transform: "translate(1089 213.53)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow2);
export default __webpack_public_path__ + "static/media/leftArrow2.3b44f5ca540af518644f31f4bd424229.svg";
export { ForwardRef as ReactComponent };